/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Update_Marker_ButtonInputs */



/**
* | output |
* | --- |
* | "Update Marker" |
*
* @param {Markers_Update_Marker_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_update_marker_button = /** @type {((inputs?: Markers_Update_Marker_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Update_Marker_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre a jour le marqueur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisierungsmarkierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna marcatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить маркер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar marcador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("更新マーカー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar marcador")
	return /** @type {LocalizedString} */ ("Update Marker")
});